import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CornerDownRight } from "lucide-react";
import { photoSrc } from "@/components/RoomPhotosUploader";

export default function ReviewCard({ review, canReply, onReplied, testId }) {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState("");

  const send = async () => {
    try {
      await api.post(`/reviews/${review.id}/reply`, { body });
      toast.success("Réponse publiée");
      setOpen(false); setBody("");
      onReplied && onReplied();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  return (
    <div className="sc-card" data-testid={testId || `review-${review.id}`}>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          {review.author_photo
            ? <img data-testid={`review-author-photo-${review.id}`} src={photoSrc(review.author_photo)} alt="" className="w-8 h-8 rounded-full object-cover border border-slate-200" />
            : <div className="w-8 h-8 rounded-full bg-slate-100 text-slate-600 grid place-items-center text-xs font-bold">{(review.author_name || "?")[0]}</div>}
          <div className="font-semibold">{review.author_name}</div>
        </div>
        <div className="flex items-center gap-1 text-orange-500 text-sm">{"★".repeat(review.rating)}<span className="text-slate-400">{"★".repeat(5 - review.rating)}</span></div>
      </div>
      <p className="text-sm text-slate-700 mt-2">{review.comment}</p>
      {review.photo_url && <img data-testid={`review-photo-${review.id}`} src={photoSrc(review.photo_url)} alt="Photo de l'avis" className="mt-3 w-full max-h-64 object-cover rounded-xl border border-slate-200" />}
      {review.reply && (
        <div className="mt-3 ml-3 pl-3 border-l-2 border-emerald-400 bg-emerald-50/50 rounded-r-xl py-2 pr-2" data-testid={`review-reply-${review.id}`}>
          <div className="text-xs font-semibold text-emerald-800 flex items-center gap-1"><CornerDownRight className="w-3 h-3" /> Réponse de {review.reply.author_name}</div>
          <p className="text-sm text-slate-700 mt-1">{review.reply.body}</p>
        </div>
      )}
      {canReply && !review.reply && (
        open ? (
          <div className="mt-3">
            <textarea data-testid={`reply-input-${review.id}`} className="w-full border border-slate-200 rounded-xl p-2 text-sm" rows={2} placeholder="Votre réponse publique…" value={body} onChange={(e) => setBody(e.target.value)} />
            <div className="mt-2 flex gap-2 justify-end">
              <button onClick={() => setOpen(false)} className="sc-btn sc-btn-outline text-xs">Annuler</button>
              <button data-testid={`reply-submit-${review.id}`} onClick={send} disabled={!body.trim()} className="sc-btn sc-btn-emerald text-xs disabled:opacity-50">Publier la réponse</button>
            </div>
          </div>
        ) : (
          <button data-testid={`reply-btn-${review.id}`} onClick={() => setOpen(true)} className="mt-3 text-xs font-semibold text-emerald-700 hover:underline flex items-center gap-1"><CornerDownRight className="w-3 h-3" /> Répondre publiquement</button>
        )
      )}
    </div>
  );
}
